export default __webpack_public_path__ + "static/media/allFractals.62cb4ba0.png";